import React from "react";
import { connect } from "react-redux";
import { generatePath, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants";
import { general } from "../../../../store/action";
import Icon from "../../general/icon";
import { getCellValue } from "../../../../utils/utils";
import {MtoJFullDateFormat} from "../../../../utils/date";
import Tooltip from "../../general/tooltip";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";

const DeviceCardsBoxItem = ({
  item,
  dataListTitles,
  handleShowModal
}) => {
  const navigate = useNavigate();
  const {findAccessInAccessList} = useFindAccessInAccessList();

  return(
    <div className="box-shadow rounded mb-4 px-4 py-3 mt-2 mx-2">
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="deviceCode">{dataListTitles[0]}</label>
        <span className="mr-2">{getCellValue(item?.deviceCode)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="type">{dataListTitles[1]}</label>
        <span className="mr-2">{getCellValue(item?.type?.name)}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="manufactureDate">{dataListTitles[2]}</label>
        <span className="mr-2">
          <bdi>{getCellValue(MtoJFullDateFormat(item?.manufactureDate))}</bdi>
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between my-3">
        <label className="text-gray mb-0" htmlFor="assignedCount">{dataListTitles[3]}</label>
        {
          item?.assignedCount ?
            <span className='px-3 py-1 rounded bg-light-green text-green2 text-nowrap'>
              دستگاه {getCellValue(item?.assignedCount)} بار تخصیص یافته است
            </span> :
            <span className='px-3 py-1 rounded bg-light-red text-red text-nowrap'>
              دستگاه تخصیص نیافته است
            </span>
        }
      </div>
      <div className="d-flex align-items-center justify-content-end my-3">
        <div className="d-flex align-items-center">
          {
            findAccessInAccessList('DEVICE_ASSIGNMENT_VIEW') &&
            <Tooltip alt={'لیست تخصیص های دستگاه'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => navigate(generatePath(ROUTES.DEVICE_ASSIGNED_LIST.PATH, {id: item?.id}))}
                className="d-flex text-hover mx-2 font-18 cur-pointer"
              >
                <Icon name='eye'/>
              </span>
            </Tooltip>
          }
          {
            findAccessInAccessList('DEVICE_ASSIGNMENT_CREATE') &&
            <Tooltip alt={'تخصیص دستگاه'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => navigate(generatePath(ROUTES.ASSIGN_DEVICE.PATH, {id: item?.id}))}
                className="d-flex text-hover mx-2 font-18 cur-pointer"
              >
                <Icon name='archive-down'/>
              </span>
            </Tooltip>
          }
          {
            findAccessInAccessList('DEVICE_VIEW') &&
            <Tooltip alt={'ویرایش'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => navigate(generatePath(ROUTES.DEVICE_EDIT.PATH, {id: item?.id}))}
                className="d-flex text-hover mx-2 font-18 cur-pointer"
              >
                <Icon name='pen-square'/>
              </span>
            </Tooltip>
          }
          {
            findAccessInAccessList('DEVICE_DELETE') &&
            <Tooltip alt={'حذف'} placement='bottom' className="tooltip-pre-line">
              <span
                onClick={() => handleShowModal('deleteDeviceModal', item?.id)}
                className="d-flex text-red-hover mr-2 font-20 cur-pointer"
              >
                <Icon name='trash'/>
              </span>
            </Tooltip>
          }
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  handleShowModal: (data, body) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(DeviceCardsBoxItem);